export const Image = ({ title, largeImage, smallImage }) => {
  const tags = title.split(";");
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        <a href={largeImage} target="blank">
          <div className="hover-text">
            {tags.map((tag, i) => (
              <h4 key={i}>{tag}</h4>
            ))}
          </div>
          <img src={smallImage} className="img-responsive" alt={title} />
        </a>
      </div>
    </div>
  );
};
